var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#28A745"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7801 19.8813C41.4952 20.5964 41.4952 21.7578 40.7801 22.4729L26.1342 37.1187C25.4191 37.8338 24.2577 37.8338 23.5426 37.1187L16.2197 29.7958C15.5046 29.0807 15.5046 27.9193 16.2197 27.2042C16.9348 26.489 18.0962 26.489 18.8113 27.2042L24.8413 33.2284L38.1942 19.8813C38.9093 19.1661 40.0707 19.1661 40.7858 19.8813H40.7801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolid);
export default __webpack_public_path__ + "static/media/check-solid.2e932d31.svg";
export { ForwardRef as ReactComponent };